import { render, staticRenderFns } from "./dataCenter-echart1.vue?vue&type=template&id=181d2436&scoped=true&"
import script from "./dataCenter-echart1.vue?vue&type=script&lang=js&"
export * from "./dataCenter-echart1.vue?vue&type=script&lang=js&"
import style0 from "./dataCenter-echart1.vue?vue&type=style&index=0&id=181d2436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d2436",
  null
  
)

export default component.exports